<router-outlet></router-outlet>

<div *ngIf="isNetworkIndicatorActive" class="network-indicator">
  <div class="spinner-border spinner-border-sm" role="status">
    <span class="sr-only"></span>
  </div>

  <div class="ml-2">Loading</div>
</div>
